module.exports = __webpack_public_path__ + "static/media/predio-grupo-aspecir.84d65d85.jpg";